import type { ApiError, ApiResponse } from "../api/http";

export type PortalQueryError = Error & ApiError;

const queryError = (error: ApiError): PortalQueryError =>
  Object.assign(new Error(error.message), error);

export const requireData = <T>(response: ApiResponse<T>): T => {
  if (response.error) throw queryError(response.error);
  if (response.data === null) {
    throw queryError({ message: "API returned no data" });
  }
  return response.data;
};

// React StrictMode mounts, immediately cleans up, and mounts effects again in
// development. Yielding once lets the first observer's AbortSignal cancel
// before an HTTP request starts, while the surviving observer still performs
// exactly one cancellable request.
export const yieldToCancellation = async (signal: AbortSignal) => {
  await Promise.resolve();
  if (signal.aborted) {
    throw new DOMException("request was cancelled", "AbortError");
  }
};
